import { ChangeDetectorRef, Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import * as _ from 'lodash';
import moment from 'moment';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { forkJoin } from 'rxjs';
import { ButtonRendererComponent } from 'src/app/renderer/button-renderer.component';
import { UsersService } from 'src/app/_services/admin/users.service';
import { GlobalJobordersService } from 'src/app/_services/global-joborders.service';
import { DeleteRecordService } from 'src/app/_services/delete-record.service';
import { JobOrdersService } from 'src/app/_services/job-orders.service';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { TasksService } from 'src/app/_services/tasks.service';
import { UtilServiceService } from 'src/app/_services/utilService/util-service.service';
import { ErrorUtil } from 'src/app/_utilities/error';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import { AuthenticationService } from 'src/app/auth/authentication.service';

declare var google: any;
declare var $: any;

interface JoJourneyRow {
  id: number;
  dateTime: string;
  name: string;
  from: string;
  to: string;
  distanceTravelled: string;
  duration: string;
  createdVia: string;
}

@Component({
  selector: 'app-jo-time-journey',
  templateUrl: './jo-time-journey.component.html',
  styleUrls: ['./jo-time-journey.component.scss'],
  standalone: false,
})
export class JoTimeJourneyComponent extends SubscriptionUtil implements OnInit {
  /** Set by the modal service, same as the task journey modal. */
  data: any;

  translate: any;
  title = 'Job Journey';
  loadList = 0;
  journeys: JoJourneyRow[] = [];
  visibleJourneys: JoJourneyRow[] = [];
  searchValue = '';
  searchValueData = false;
  totalRecord = 0;
  gridApi: any;
  columnDefs: ColDef[] = [];
  defaultColDef: any;
  frameworkComponents: any;
  gridOptions: any;
  overlayNoRowsTemplate = "<div class='not-found'><span>No Records Found</span></div>";

  users: any[] = [];
  customerData: any[] = [];
  homeAddress: any = null;
  officeAddress: any = null;
  locationByTaskData: any[] = [];
  locationByEndTaskData: any[] = [];
  distanceData: any = null;
  distanceKM: any = '';
  locationNotSelected = false;
  newJourney: any = this.emptyJourney();
  formSubmitted = false;
  private autocomplete: any;
  private autocomplete1: any;
  private autocompleteLsr: any;
  private autocompleteLsr1: any;
  private fromAutocompleteReady = true;
  private toAutocompleteReady = true;
  private deleteRefreshSubscribed = false;

  @ViewChild('fromAddressSearch', { static: false }) fromAddressSearchElementRef!: ElementRef;
  @ViewChild('toAddressSearch', { static: false }) toAddressSearchElementRef!: ElementRef;

  constructor(
    public modalRef: BsModalRef,
    private languageTranslateService: LanguageTranslateService,
    private auth: AuthenticationService,
    private jobOrdersService: JobOrdersService,
    private deleteRecordService: DeleteRecordService,
    private taskService: TasksService,
    private globalJobordersService: GlobalJobordersService,
    private userService: UsersService,
    private errorUtil: ErrorUtil,
    private utilService: UtilServiceService,
    private ngZone: NgZone,
    private cdRef: ChangeDetectorRef,
  ) {
    super();
  }

  private emptyJourney() {
    return {
      dateTime: null as Date | null,
      userId: null as number | null,
      fromType: null as string | null,
      toType: null as string | null,
      fromTaskId: null,
      toTaskId: null,
      startLocation: { address: null as string | null, coordinate: { latitude: null, longitude: null } },
      endLocation: { address: null as string | null, coordinate: { latitude: null, longitude: null } },
    };
  }

  ngOnInit(): void {
    this.frameworkComponents = { buttonRenderer: ButtonRendererComponent };
    this.gridOptions = {
      rowModelType: 'clientSide',
      paginationPageSize: 25,
      onGridSizeChanged: (params: any) => params.api.sizeColumnsToFit(),
    };
    this.defaultColDef = { sortable: true, resizable: true, filter: false };
    this.push(this.languageTranslateService.wordSrc$.subscribe(data => {
      if (Object.keys(data).length != 0) {
        this.translate = data;
        this.buildColumns();
      }
    }));
    this.buildColumns();
    this.loadJourneys();
  }

  private buildColumns() {
    this.columnDefs = [
      { headerName: 'Date & Time', field: 'dateTime', width: 180 },
      { headerName: 'Name', field: 'name', width: 160 },
      { headerName: 'From', field: 'from', width: 180 },
      { headerName: 'To', field: 'to', width: 180 },
      { headerName: 'Distance Travelled', field: 'distanceTravelled', width: 140 },
      { headerName: 'Duration', field: 'duration', width: 110 },
      { headerName: 'Created Via', field: 'createdVia', width: 130 },
      {
        headerName: this.translate?.general?.buttons?.action?.singular || 'Action',
        sortable: false,
        filter: false,
        width: 110,
        cellRenderer: 'buttonRenderer',
        cellRendererParams: {
          onClick: this.onRowAction.bind(this),
          permissions: { update: false, remove: true },
          hidden: { update: true, remove: false },
        },
      },
    ];
  }

  loadJourneys() {
    const jobOrderId = this.data?.id ?? this.data?.jobOrderId;
    if (jobOrderId == null) {
      this.journeys = [];
      this.applySearch();
      return;
    }
    this.push(this.jobOrdersService.getJobOrderRoutes(jobOrderId).subscribe({
      next: (res: any) => {
        const timezone = this.auth.getUserTimezone();
        const dateFormat = localStorage.getItem('date_format') || 'DD-MM-YYYY';
        this.journeys = this.extractRoutes(res).map((item) => this.toJourneyRow(item, timezone, dateFormat)).reverse();
        this.applySearch();
      },
      error: () => {
        this.journeys = [];
        this.applySearch();
      },
    }));
  }

  private extractRoutes(res: any): any[] {
    if (!res) {
      return [];
    }
    if (Array.isArray(res)) {
      return res;
    }
    const source = res.data && !Array.isArray(res.data) ? res.data : res;
    const list = (Array.isArray(res.data) ? res.data : null)
      || source.jobOrderLocationRouteVMList
      || source.userLocationRouteVMList
      || source.content;
    return Array.isArray(list) ? list : [];
  }

  private toJourneyRow(item: any, timezone: string, dateFormat: string): JoJourneyRow {
    const route = item?.jobOrderLocationRouteTable || item?.userLocationRouteTable || item || {};
    const started = route.startDateTime || route.dateTime;
    const distance = route.totalDistanceTravelled ?? route.distanceTravelled;
    return {
      id: route.id,
      dateTime: started
        ? moment.tz(started, timezone).format('hh:mm A, ' + dateFormat.toUpperCase())
        : '-',
      name: route.userFullName || route.name || this.data?.orderOwner?.name || '-',
      from: route.startLocationAddress || route.startLocation?.address || route.from || '-',
      to: route.endLocationAddress || route.endLocation?.address || route.to || '-',
      distanceTravelled: this.formatDistance(distance),
      duration: this.formatDuration(route.duration ?? route.travelTimeMinutes),
      createdVia: route.systemGenerated === false ? 'Web Generation' : 'Mobile GPS',
    };
  }

  private formatDistance(distance: any): string {
    if (distance == null || distance === '') {
      return '-';
    }
    const value = Number(distance);
    if (Number.isNaN(value)) {
      return String(distance);
    }
    return value === 0 ? '0.0 KM' : `${value} KM`;
  }

  private formatDuration(duration: any): string {
    if (duration == null || duration === '') {
      return '-';
    }
    if (typeof duration === 'number') {
      return this.formatMinutes(duration);
    }
    return String(duration);
  }

  private formatMinutes(minutes: number | null | undefined): string {
    if (minutes == null) return '-';
    const total = Math.round(minutes);
    if (total < 60) return `${total} min`;
    const hours = Math.floor(total / 60);
    const mins = total % 60;
    return mins ? `${hours}h ${mins}m` : `${hours}h`;
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    params.api.sizeColumnsToFit();
  }

  quickSearch() {
    this.searchValueData = this.searchValue.length > 0;
    this.applySearch();
  }

  onSearch() {
    if (!this.searchValue.length) {
      this.searchValueData = false;
      this.applySearch();
    }
  }

  onClear() {
    this.searchValue = '';
    this.searchValueData = false;
    this.applySearch();
  }

  private applySearch() {
    const query = this.searchValue.trim().toLowerCase();
    this.visibleJourneys = !query
      ? [...this.journeys]
      : this.journeys.filter((row) =>
          [row.name, row.from, row.to].some((value) => (value || '').toLowerCase().includes(query))
        );
    this.totalRecord = this.visibleJourneys.length;
  }

  onRowAction(event: any) {
    if (event.action !== 'delete' || event.rowData?.id == null) {
      return;
    }
    event.rowData.deleteHeader = `${this.translate?.jobOrder?.label?.singular || 'Job Order'} ${this.translate?.journey?.label?.singular || 'Journey'}`;
    event.rowData.deleteType = 'Job Order Journey';
    event.rowData.message = this.translate?.general.messages.confirmDelete;
    const refresh$ = this.deleteRecordService.getItems(event.rowData);
    if (!this.deleteRefreshSubscribed) {
      this.deleteRefreshSubscribed = true;
      this.push(refresh$.subscribe((data: any) => {
        if (data?.deleteType === 'Job Order Journey') {
          this.loadJourneys();
        }
      }));
    }
  }

  openNewForm() {
    this.newJourney = this.emptyJourney();
    this.newJourney.dateTime = new Date();
    this.distanceData = null;
    this.distanceKM = '';
    this.locationNotSelected = false;
    this.formSubmitted = false;
    this.fromAutocompleteReady = true;
    this.toAutocompleteReady = true;
    this.loadList = 1;
    this.title = 'New Job Journey';
    this.loadJourneyUsers();
  }

  goBackTablePage() {
    this.loadList = 0;
    this.title = 'Job Journey';
  }

  private loadJourneyUsers() {
    const jobOrderId = this.data?.id ?? this.data?.jobOrderId;
    const serverRequest = {
      startRow: 0,
      pageSize: 100,
      filterModel: null,
      sortModel: [{ colId: 'taskNumber', sort: 'asc' }],
    };
    this.push(this.globalJobordersService.getJOTasks(jobOrderId, serverRequest, false, 'jobOrder').subscribe({
      next: (res: any) => {
        const taskIds = Array.from(new Set((res?.body?.data || []).map((task: any) => task.id).filter((id: any) => id != null)));
        if (!taskIds.length) {
          this.loadOwnerProfile();
          return;
        }
        this.push(forkJoin(taskIds.map((id) => this.taskService.getUsersByTask(id))).subscribe((lists: any[]) => {
          const merged = new Map<number, any>();
          lists.forEach((list) => {
            (Array.isArray(list) ? list : []).forEach((user) => {
              if (user?.id != null && !merged.has(user.id)) {
                merged.set(user.id, user);
              }
            });
          });
          this.users = Array.from(merged.values());
          this.selectDefaultUser();
        }));
      },
      error: () => this.loadOwnerProfile(),
    }));
  }

  private loadOwnerProfile() {
    const ownerId = this.ownerId();
    if (ownerId == null) {
      return;
    }
    this.push(this.userService.getUserProfile(ownerId).subscribe((user: any) => {
      if (user?.id != null) {
        this.users = [user];
        this.selectDefaultUser();
      }
    }));
  }

  private ownerId() {
    return this.data?.orderOwner?.id || this.data?.generalDetails?.owner?.id || null;
  }

  private selectDefaultUser() {
    const ownerId = this.ownerId();
    const owner = this.users.find((user) => user.id == ownerId);
    this.newJourney.userId = owner ? Number(owner.id) : (this.users[0] ? Number(this.users[0].id) : null);
    if (this.newJourney.userId != null && !this.users.some((user) => user.id == this.newJourney.userId)) {
      this.push(this.userService.getUserProfile(this.newJourney.userId).subscribe((user: any) => {
        if (user) {
          this.users = [...this.users, user];
          this.onUserChange();
        }
      }));
      return;
    }
    this.onUserChange();
  }

  onUserChange() {
    this.customerData = _.filter(this.users, (user) => user.id == this.newJourney.userId);
    this.setAddressByUserSelected();
    this.newJourney.fromType = null;
    this.newJourney.toType = null;
    this.newJourney.fromTaskId = null;
    this.newJourney.toTaskId = null;
    this.newJourney.startLocation = { address: null, coordinate: { latitude: null, longitude: null } };
    this.newJourney.endLocation = { address: null, coordinate: { latitude: null, longitude: null } };
    this.clearCalculation();
  }

  private setAddressByUserSelected() {
    this.homeAddress = null;
    this.officeAddress = null;
    const user = this.customerData[0];
    if (!user) {
      return;
    }
    const join = (keys: string[]) => keys
      .map((key) => user[key])
      .filter((value) => value != null && value !== '')
      .join(', ');
    const home = join(['homeStreet', 'homeCity', 'homeState', 'homePostcode', 'homeCountry']);
    const office = join(['officeStreet', 'officeCity', 'officeState', 'officePostcode', 'officeCountry']);
    if (home) {
      this.homeAddress = { address: home, lat: user.homeLatitude, lng: user.homeLongitude };
    }
    if (office) {
      this.officeAddress = { address: office, lat: user.officeLatitude, lng: user.officeLongitude };
    }
  }

  setStartLocation(val: string) {
    this.newJourney.fromType = val;
    this.newJourney.fromTaskId = null;
    this.clearCalculation();
    if (val === 'Current Location') {
      this.setCurrentLocation('start');
    } else if (val === 'Home') {
      this.applySavedAddress('start', this.homeAddress, this.translate?.task.messages.homeAddrNotSet);
    } else if (val === 'Office') {
      this.applySavedAddress('start', this.officeAddress, this.translate?.task.messages.officeAddrNotSet);
    } else if (val === 'Task') {
      this.newJourney.startLocation = { address: null, coordinate: { latitude: null, longitude: null } };
      this.getLocationByTask();
    }
  }

  setEndLocation(val: string) {
    this.newJourney.toType = val;
    this.newJourney.toTaskId = null;
    this.clearCalculation();
    if (val === 'Current Location') {
      this.setCurrentLocation('end');
    } else if (val === 'Home') {
      this.applySavedAddress('end', this.homeAddress, this.translate?.task.messages.homeAddrNotSet);
    } else if (val === 'Office') {
      this.applySavedAddress('end', this.officeAddress, this.translate?.task.messages.officeAddrNotSet);
    } else if (val === 'Task') {
      this.newJourney.endLocation = { address: null, coordinate: { latitude: null, longitude: null } };
      this.getLocationByTask();
    }
  }

  private applySavedAddress(target: 'start' | 'end', address: any, missingMessage: string) {
    const location = target === 'start' ? this.newJourney.startLocation : this.newJourney.endLocation;
    if (address) {
      location.address = address.address;
      location.coordinate.latitude = address.lat;
      location.coordinate.longitude = address.lng;
      return;
    }
    location.address = null;
    location.coordinate.latitude = null;
    location.coordinate.longitude = null;
    const user = this.customerData[0];
    const name = user ? `${user.firstName || ''} ${user.lastName || ''}`.trim() : '';
    this.errorUtil.setErrorMessage(200, `${name} ${missingMessage || ''}`.trim(), null, 'warn', 3000);
  }

  private setCurrentLocation(target: 'start' | 'end') {
    if (!('geolocation' in navigator) || typeof google === 'undefined') {
      return;
    }
    const geocoder = new google.maps.Geocoder();
    navigator.geolocation.getCurrentPosition((position) => {
      const latitude = position.coords.latitude;
      const longitude = position.coords.longitude;
      geocoder.geocode({ location: { lat: latitude, lng: longitude } }, (results: any, status: any) => {
        if (status !== google.maps.GeocoderStatus.OK || !results?.[0]) {
          return;
        }
        const precise = _.remove(results, (result: any) => result.geometry.location_type === 'APPROXIMATE');
        const match = precise[0] || results[0];
        this.ngZone.run(() => {
          const location = target === 'start' ? this.newJourney.startLocation : this.newJourney.endLocation;
          location.address = match.formatted_address;
          location.coordinate.latitude = latitude;
          location.coordinate.longitude = longitude;
          this.cdRef.detectChanges();
        });
      });
    });
  }

  getLocationByTask() {
    if (!this.newJourney.userId || !this.newJourney.dateTime) {
      return;
    }
    const startDate = moment(this.newJourney.dateTime).format('YYYY-MM-DD');
    this.push(this.taskService.getLocationByTask(this.newJourney.userId, startDate).subscribe((res: any) => {
      const rows = (Array.isArray(res) ? res : []).map((element: any) => ({
        ...element,
        disabled: false,
        customeName: `${element.taskName} - ${element.location}`,
      }));
      this.locationByTaskData = rows.map((row) => ({ ...row }));
      this.locationByEndTaskData = rows.map((row) => ({ ...row }));
    }));
  }

  getTaskDetail(taskType: 'startLocation' | 'endLocation', selectedTask: any) {
    const source = taskType === 'startLocation' ? this.locationByTaskData : this.locationByEndTaskData;
    const match = _.find(source, (row) => row.id == selectedTask);
    if (!match) {
      return;
    }
    const location = taskType === 'startLocation' ? this.newJourney.startLocation : this.newJourney.endLocation;
    location.address = match.location;
    location.coordinate.latitude = match.latitude;
    location.coordinate.longitude = match.longitude;
    this.clearCalculation();
  }

  getPlaceApiCall(event: any) {
    const value = event.target.value || '';
    if (value.length < 3) {
      this.clearAutocomplete('from');
      this.fromAutocompleteReady = true;
    } else if (this.fromAutocompleteReady) {
      this.bindAutocomplete('from');
      this.fromAutocompleteReady = false;
    }
  }

  getPlaceApiCall1(event: any) {
    const value = event.target.value || '';
    if (value.length < 3) {
      this.clearAutocomplete('to');
      this.toAutocompleteReady = true;
    } else if (this.toAutocompleteReady) {
      this.bindAutocomplete('to');
      this.toAutocompleteReady = false;
    }
  }

  private bindAutocomplete(target: 'from' | 'to') {
    if (typeof google === 'undefined') {
      return;
    }
    const element = target === 'from' ? this.fromAddressSearchElementRef?.nativeElement : this.toAddressSearchElementRef?.nativeElement;
    if (!element) {
      return;
    }
    const autocomplete = new google.maps.places.Autocomplete(element, {
      fields: ['place_id', 'geometry', 'name', 'formatted_address', 'types'],
    });
    const listener = autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();
      if (!place?.geometry) {
        return;
      }
      this.ngZone.run(() => {
        const location = target === 'from' ? this.newJourney.startLocation : this.newJourney.endLocation;
        const address = place.types?.includes('establishment')
          ? `${place.name}, ${place.formatted_address}`
          : place.formatted_address;
        location.address = address;
        location.coordinate.latitude = place.geometry.location.lat();
        location.coordinate.longitude = place.geometry.location.lng();
        if (target === 'from') {
          this.newJourney.fromTaskId = null;
        } else {
          this.newJourney.toTaskId = null;
        }
        this.clearCalculation();
        this.cdRef.detectChanges();
      });
    });
    if (target === 'from') {
      this.autocomplete = autocomplete;
      this.autocompleteLsr = listener;
    } else {
      this.autocomplete1 = autocomplete;
      this.autocompleteLsr1 = listener;
    }
  }

  private clearAutocomplete(target: 'from' | 'to') {
    const autocomplete = target === 'from' ? this.autocomplete : this.autocomplete1;
    const listener = target === 'from' ? this.autocompleteLsr : this.autocompleteLsr1;
    if (listener && typeof google !== 'undefined') {
      google.maps.event.removeListener(listener);
    }
    if (autocomplete && typeof google !== 'undefined') {
      google.maps.event.clearInstanceListeners(autocomplete);
    }
    if (typeof $ !== 'undefined') {
      $('.pac-container').remove();
    }
  }

  clearCalculation() {
    this.distanceData = null;
    this.distanceKM = '';
    this.locationNotSelected = false;
  }

  calculate() {
    const start = this.newJourney.startLocation.coordinate;
    const end = this.newJourney.endLocation.coordinate;
    if (start.latitude == null || start.longitude == null || end.latitude == null || end.longitude == null) {
      this.locationNotSelected = true;
      return;
    }
    this.locationNotSelected = false;
    this.push(this.taskService.getCalculateDistance(this.newJourney).subscribe((resp: any) => {
      this.distanceData = resp;
      this.distanceKM = (this.distanceData.newRecordId / 1000).toFixed(2);
    }));
  }

  saveJourney() {
    this.formSubmitted = true;
    const start = this.newJourney.startLocation;
    const end = this.newJourney.endLocation;
    const jobOrderId = this.data?.id ?? this.data?.jobOrderId;
    if (!this.newJourney.dateTime || this.newJourney.userId == null || !start?.address || !end?.address || jobOrderId == null) {
      return;
    }
    if (start.coordinate?.latitude == null || start.coordinate?.longitude == null || end.coordinate?.latitude == null || end.coordinate?.longitude == null) {
      this.locationNotSelected = true;
      return;
    }
    const startTime = moment(this.newJourney.dateTime).tz(this.auth.getUserTimezone()).format('hh:mm A');
    const formattedStart = this.utilService.timeFormatter(startTime, this.newJourney.dateTime);
    const body = {
      jobOrderId,
      userId: this.newJourney.userId,
      startDateTime: moment(formattedStart).utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z',
      startLocation: {
        address: start.address,
        coordinate: {
          latitude: Number(start.coordinate.latitude),
          longitude: Number(start.coordinate.longitude),
        },
      },
      endLocation: {
        address: end.address,
        coordinate: {
          latitude: Number(end.coordinate.latitude),
          longitude: Number(end.coordinate.longitude),
        },
      },
    };
    this.push(this.jobOrdersService.saveJobOrderRoute(body).subscribe({
      next: (res: any) => {
        if (res.status === 200 || res.status === 201) {
          this.errorUtil.setErrorMessage(200, this.translate?.general.messages.savedSuccessfully, null, 'success', 1000);
          this.goBackTablePage();
          this.loadJourneys();
          return;
        }
        this.errorUtil.setErrorMessage(res.status, null, res.error?.title, 'error', 2000);
      },
      error: (err) => {
        const title = this.errorUtil.processErrorTitle(err.error, this.translate);
        this.errorUtil.setErrorMessage(err.status, null, title, 'error', 3000);
      },
    }));
  }
}
